var api = "//api.qingcigame.com/thai";
var index = '';
var go_page = window.location.href.split('?page=')[1];
var obj = {
    index: function() {
        this.preloading(); // 预加载
        this.indexBind(); // 首页按钮
        this.downUrl(); //下载地址
        this.countNum(); //bl埋点
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            var _this = this;
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').addClass('index-show');
            this.indexSwiper();
            if (go_page == undefined) {
                // pv暂时未提供，先隐藏
                this.defaultVideo();
            }
            setTimeout(function() {
                $('.preloading').remove();
            }, 1000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '/official/images/pc/m_dt_sz-5c4ca25bcc.png',
            '/official/images/pc/m_dt_t-d892b8ad0b.png',
            '/official/images/pc/m_jdt-31fdd64c97.png',
            '/official/images/pc/header_bg-e0ddd5d800.png',
            '/official/images/pc/snail_ke-fda25e0735.png',
            '/official/images/pc/snail-9998727df1.png',
            '/official/images/pc/index_bg-0c7b5c55dc.png'
        ]);
    },
    // 首页暂未开放的几个按钮
    indexBind: function() {
        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            obj.countNum(mon_btn);
        });

        $('.flame').hover(function() {
            $(this).find('i').addClass('disappear')
        }, function() {
            $(this).find('i').removeClass('disappear')
        });

        $('.role-ani').click(function(event) {
            var _this = $(this);
            if (!_this.hasClass('rubberBand2'))
                _this.addClass('rubberBand2')
            setTimeout(function() { _this.removeClass('rubberBand2') }, 1000);
        });

        // discord line 弹窗敬请期待
        $('.discord-btn,.line-btn').on('click', function() {
            showHint("โปรดคอยติดตาม");
        });

        function showHint(val) {
            $(".hint").css("display", "block");
            $(".hint .hint_wrap .hint_text").text(val);
            setTimeout(() => {
                $(".hint").fadeOut();
            }, 1500)
        }
        // 匹配机型 替换图标
        if (navigator.userAgent.match(/(iPhone|iPod|ios)/i)) {
            // $(".google-btn").attr("class", "app-btn")
            $(".google-btn").attr({ "class": "app-btn", "data-event": "AppStore" })
        }

        // 雷电弹窗
        $('.download-tips').on('click', function(event) {
            $('.leidian-wrap , .popup-leidian').fadeIn();
        });
    },
    defaultVideo: function() {
        var src = '//www.youtube.com/embed/mSQMtfaWqyc';
        $('.play-btn').fadeIn().attr('data', src);
        // $('.video-wrap, .popup-video').fadeIn().find('iframe').attr('src', $('.play-btn').attr('data')).removeClass('ani-btn');

        $('.play-btn').on('click', function(event) {
            obj.countNum('video-play');
            $('.video-wrap, .popup-video').fadeIn().find('iframe').attr('src', $('.play-btn').attr('data')).removeClass('ani-btn');
        });
        $('.popup').on('click', '.close-btn', function(event) {
            $('.video-wrap, .popup-video').fadeOut().find('iframe').attr('src', '');
            $('.leidian-wrap, .popup-leidian').fadeOut();
        });
    },
    // 首页轮播
    indexSwiper: function() {
        //商店卡片轮播
        var mySwiper2 = new Swiper('.swiper-container-card', {
            loop: true,
            pagination: '.swiper-pagination2',
            paginationClickable: true,
            noSwiping: true,
            autoplay: 2000,
            autoplayDisableOnInteraction: false,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            effect: 'coverflow',
            centeredSlides: true,
            slidesPerView: 'auto',
            coverflow: {
                rotate: 0, // 旋转的角度
                stretch: 5, // 拉伸   图片间左右的间距和密集度
                depth: 30, // 深度   切换图片间上下的间距和密集度
                modifier: 10, // 修正值 该值越大前面的效果越明显
                // slideShadows : false// 页面阴影效果
            },
            onInit: function(swiper) {
                swiperAnimate(swiper);
                swiper.stopAutoplay();
            },
        })

        var mySwiper = new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            direction: 'vertical',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            mousewheelControl: true,
            resistanceRatio: 0,
            onInit: function(swiper) {
                swiperAnimate(swiper);

                function Ani(btn, page) {
                    $(btn).on('click', function() {
                        mySwiper.slideTo(page, 1000, true);
                    });
                };

                function navLink() {
                    for (var i = 6; i >= 0; i--) {
                        Ani('.nav-link-0' + i + ' .link-a', i);
                    };
                }
                navLink();
            },
            onSlideChangeEnd: function(swiper) {
                swiper.activeIndex >= 2 ? $('.rocket').fadeIn() : $('.rocket').fadeOut();
                swiperAnimate(swiper);
                swiper.activeIndex !== 0 ? $('.header').addClass('header-shadow') : $('.header').removeClass('header-shadow');
                $('.nav-link').removeClass('on')
                $('.nav-link-0' + swiper.activeIndex + '').addClass('on');

                if (swiper.activeIndex == 2) {
                    mySwiper2.startAutoplay();
                }
            },
        });

        if (go_page !== undefined) {
            mySwiper.slideTo(go_page - 1, 1000, true);
        }

        $('body').on('click', '.rocket', function(event) {
            var _this = $(this);
            _this.addClass('rocket-ani')
            mySwiper.slideTo(0, 1000, true);
            setTimeout(function() { _this.fadeOut() }, 1000);
            setTimeout(function() { _this.removeClass('rocket-ani') }, 1500);
        });
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    share: function() {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href,
            },
            success: function(json) {

                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    wx.config(json.data);
                    wx.ready(function() {
                        wx.updateAppMessageShareData({
                            title: '最强蜗牛', // 分享标题
                            desc: '大家都爱玩的沙雕手游', // 分享描述
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {}
                        })

                        wx.updateTimelineShareData({
                            title: '最强蜗牛-大家都爱玩的沙雕手游', // 分享标题
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {
                                // 设置成功
                            }
                        })
                    });
                    return;
                } else {
                    try {
                        setShareInfo({
                            title: '最强蜗牛', // 分享标题
                            summary: '大家都爱玩的沙雕手游', // 分享内容
                            pic: 'https://static.qcplay.com/common/snail_icon.png', // 分享图片
                            url: window.location.href, // 分享链接
                            // 微信权限验证配置信息，若不在微信传播，可忽略
                            WXconfig: {
                                swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                                appId: json.data.appId, // 公众号的唯一标识
                                timestamp: json.data.timestamp, // 生成签名的时间戳
                                nonceStr: json.data.nonceStr, // 生成签名的随机串
                                signature: json.data.signature // 签名
                            }
                        });
                    } catch (err) {}
                }
            }
        })
    },
    // 下载地址
    downUrl: function() {
        var googleUrl = '//play.google.com/store/apps/details?id=com.qcplay.snail.android.th';
        var iosUrl = '//apps.apple.com/th/app/super-snail/id1641227248';

        $('.google-btn').attr('href', googleUrl)
        $('.app-btn').attr('href', iosUrl)
    },
    // bl埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    }
}